module.exports = __webpack_public_path__ + "img/logo_full.db9bd5ed.svg";